import LicenseRegistrationComponent from "../components/license-registration/LicenseRegistration";

export default function LicenseRegistration() {
  return <LicenseRegistrationComponent />;
}
